<template>
  <div v-if="showModal">
    <div id="modal" class="modal-mask" transition="modal">
      <div class="modal-container">
        <div style="position:relative;">
          <div
            style="position:absolute;top: -27px;right: -18px;cursor:pointer;"
            @click="hide()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#dae12f"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </div>

          <div class="modal-body">
            <p
              class="fullwidth mt-3 mb-2"
              style="font-size: 20px;line-height: 22px;font-weight: bold;"
            >
              Sila pilih avatar untuk profil anda
            </p>

            <div class="container">
              <div class="row">
                <div
                  class="col-6 col-sm-4 my-2"
                  style="cursor:pointer;"
                  v-for="avatarImg in avatarList"
                  :key="avatarImg.id"
                  @click="chooseAvatar(avatarImg)"
                >
                  <img
                    :src="
                      `https://rtm-images.glueapi.io/320x0/${
                        avatarImg.fileFullPath
                      }`
                    "
                    alt=""
                    class="w-100"
                    :class="{ selected: selected === avatarImg.id }"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="mb-1" style="font-size: 10;font-style: italic;">
                    ** Makluman: Avatar profil anda mungkin memerlukan sedikit
                    masa untuk dikemaskini.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="w-100 d-flex justify-content-center align-items center">
              <button class="modal-default-button" @click="saveAvatar()">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import PopupInterstitial from "../ads/popupInterstitial";
import axios from "axios";
import { bus } from "../../main";

export default {
  data() {
    return {
      showModal: false,
      formstate: {},
      avatarList: [],
      selected: "",
      model: {
        name: "",
        email: "",
        comments: "",
        customPopupImageLink: "",
        customPopupLink: "",
      },
      url: "",
      base64String: "",
      error: "",
      avatarfilename: "",
    };
  },
  components: {
    // popupInterstitial: PopupInterstitial
  },
  methods: {
    imageLoadError(event) {
      event.target.src = defaultAvatar;
    },
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    saveAvatar() {
      let str = this.base64String;
      let newBase64string = str.split(",")[1].trim();
      let url = "https://rtm.glueapi.io/v3/asset/image/upload";

      var token = localStorage.getItem("token");
      const config = {
        headers: { "X-AUTH-TOKEN": token },
      };

      let body = {
        subDirectory: "avatar", //sub directory name under the image s3 bucket
        imagebase64: newBase64string, //image file in imagebase64 string
        type: "avatar", //user type, the default value is avatar is not specified
      };

      axios
        .post(url, body, config)
        .then((response) => {
          // console.log(response);
          this.$cookie.set("avatar", this.avatarfilename, {
            expires: "12h",
          });
          this.hide();
          window.location.reload(true);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async chooseAvatar(obj) {
      this.selected = obj.id;
      this.url = `https://rtm-images.glueapi.io/320x0/${obj.fileFullPath}`;
      this.avatarfilename = obj.fileFullPath;

      let response = await fetch(this.url)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.base64String = reader.result;
            // this.getBase64string();
            bus.$emit("avatarChosen", this.base64String);
          };
          reader.readAsDataURL(blob);
        })
        .catch((error) => {
          console.error("Error:", error);
        });

      // let body = this.hide();
    },
    async getAvatarList() {
      let response = await axios.get(
        "https://rtm.glueapi.io/v2/asset/Image?fileFullPath=avatar&fileName=RTMKLIK&limit=20",
        {
          responseType: "json",
        }
      );

      this.avatarList = response.data.data;
    },
  },
  beforeMount() {
    this.getAvatarList();
  },
  mounted() {
    this.$watch("$refs.popupVisible.style", (new_value, old_value) =>
      console.log("i")
    );

    setTimeout(
      function() {
        this.getAvatarList();
        // this.hide();
      }.bind(this),
      13000
    );
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 100%;
  max-width: 560px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 4px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
.modal-default-button {
  background: #dae12f;
  color: #000000;
  border-radius: 4px;
  padding: 10px 25px;
  border: none;
  outline: none;
  font-size: 18px;
}
.modal-header h3 {
  margin-top: 0;
  color: #dae12f;
}
.text-yellow {
  color: #dae12f;
}
.text-black {
  color: black;
}
.text-red {
  color: red;
}
.text-bolder {
  font-weight: 900;
}
.main_title {
  font-size: 26px;
}
.modal-body {
  /* margin: 10px 0 0px; */
  padding: 0;
  height: 400px;
  overflow: auto;
}
.selected {
  border: 3px solid #8c8d89;
}
.text-right {
  text-align: right;
}

.form-label {
  display: block;
  margin-bottom: 1em;
  font-size: 16px;
  color: black;
  text-align: left;
}

.form-label > .form-control {
  margin-top: 0.5em;
}
.form-group label {
  text-align: left;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  border: 1px solid #ddd;
}

.modal-enter,
.modal-leave {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.modal-footer {
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
}
.error {
  color: red;
}
.success {
  color: green;
}
.fullwidth {
  width: 100%;
}
.announcement {
  color: black;
  font-size: 16px;
  font-weight: 500;
}
.bolder {
  font-weight: 900;
}

@media only screen and (max-width: 1280px) {
  .modal-container {
    max-width: 500px;
  }
}

@media screen and (max-width: 768px) {
  .modal-body {
    height: 340px;
    overflow: auto;
  }
  .modal-container {
    /* top: 25%;
    left: 25%;
    transform: translate(-50%, -50%); */
    width: 80%;
    max-width: 80%;
  }
  .main_title {
    font-size: 18px;
  }
  .announcement {
    font-size: 13px;
  }
  .modal-default-button {
    padding: 8px 20px;
  }
  .modal-default-button span {
    font-size: 14px;
  }
}
</style>
